import type { MutableRefObject, Ref } from 'react';

type AnyRef<T> = Ref<T> | MutableRefObject<T | null> | null | undefined;

const composeRefs =
  <T>(...args: AnyRef<T>[]): ((ref: T | null) => void) =>
  (ref: T | null): void => {
    args.forEach((arg) => {
      if (!arg) {
        return;
      }

      if (typeof arg === 'function') {
        arg(ref);

        return;
      }

      (arg as MutableRefObject<T | null>).current = ref;
    });
  };

export default composeRefs;
